import {
  TeamExternalIntegration,
  Predicate,
  ResponseBodyEvaluation
} from 'types/api/services/golden-signal'
import { IntegrationType } from 'utils/team-external-integrations/team-external-integration-types'

export const grafanaStatusCheckIntegration: TeamExternalIntegration = {
  name: 'Grafana Cloud',
  type: IntegrationType.Grafana,
  authUrl: '',
  isPrivateNetworkIntegration: false,
  headers: [{ key: 'Authorization', value: '', label: 'API Key' }],
  url: 'https://<your_domain>.grafana.net/',
  sortIndex: 3
}

export const grafanaBaseUrlRegex = new RegExp(
  '^https:\\/\\/(.+).grafana.net\\/?$'
)

export const grafanaRegex = new RegExp(
  '^https:\\/\\/(.+).grafana.net\\/alerting\\/grafana\\/([a-zA-Z0-9]+)(/view)?$'
)

export const grafanaApiAlertsRegex = new RegExp(
  '^https:\\/\\/(.+).grafana.net\\/api\\/alertmanager\\/grafana\\/api\\/v2\\/alerts\\?alertId=(.+)$'
)

export const grafanaResponseBodyEvaluationConfiguration: ResponseBodyEvaluation =
  {
    op: 'AND',
    predicates: []
  }

export function convertToGrafanaUrl(url: string): string {
  if (grafanaRegex.test(url)) {
    const domainName = grafanaRegex.exec(url)?.[1]
    const alertId = grafanaRegex.exec(url)?.[2]
    if (domainName) {
      return `https://${domainName}.grafana.net/api/alertmanager/grafana/api/v2/alerts?alertId=${alertId}`
    }
  }

  if (grafanaBaseUrlRegex.test(url)) {
    const domainName = grafanaBaseUrlRegex.exec(url)?.[1]
    return `https://${domainName}.grafana.net/api/alertmanager/grafana/api/v2/alerts`
  }

  if (grafanaApiAlertsRegex.test(url)) {
    return url
  }
  return null
}

export function convertToGrafanaBaseUrl(url: string): string {
  if (
    grafanaRegex.test(url) ||
    grafanaBaseUrlRegex.test(url) ||
    grafanaApiAlertsRegex.test(url)
  ) {
    const domainName = grafanaRegex.exec(url)?.[1]
    if (domainName) {
      return `https://${domainName}.grafana.net/`
    }
  }

  return null
}

export function getAlertIdFromUrl(url: string): string {
  if (grafanaRegex.test(url)) {
    return grafanaRegex.exec(url)?.[2]
  }

  if (grafanaApiAlertsRegex.test(url)) {
    return grafanaApiAlertsRegex.exec(url)?.[2]
  }
  return null
}

export const formatResponseBodyEvaluationPredicatesGrafana = (
  url: string
): ResponseBodyEvaluation => {
  return {
    op: 'AND',
    predicates: [
      {
        type: 'String',
        jpQuery: `[?(@.labels.__alert_rule_uid__ == '${getAlertIdFromUrl(
          url
        )}')].labels.__alert_rule_uid__`,
        rValue: getAlertIdFromUrl(url),
        comparator: 'NEQ'
      } as Predicate
    ]
  }
}
